// Use the global jQuery instead of importing it
// This fixes the "Cannot use import statement outside a module" error
jQuery(document).ready(function($) {
    'use strict';
    
    // Get the map ID from the data attribute
    const mapId = $('.map__holder').data('map-id');

    // Handle custom location list clicks
    $('.custom-location-list a').on('click', function(e) {
        e.preventDefault();
        const locationText = $(this).text().trim();
        
        // Get the map element and its data
        const $mapElement = $('.wpgmp_map');
        if ($mapElement.length) {
            const mapData = $mapElement.data('wpgmp_maps');
            
            if (mapData && mapData.map_data) {
                // Try to find the location in the places array
                if (mapData.map_data.places && mapData.map_data.places.length) {
                    // Clean up the search text by removing common suffixes and normalizing
                    const cleanSearchText = locationText
                        .toLowerCase()
                        .replace(/\s*school$/i, '')
                        .replace(/\s*academy$/i, '')
                        .replace(/\s*elementary$/i, '')
                        .replace(/\s*middle$/i, '')
                        .replace(/\s*high$/i, '')
                        .replace(/[^a-z0-9\s]/g, '') // Remove special characters
                        .replace(/\s+/g, ' ') // Normalize spaces
                        .trim();
                    
                    // Find the place with matching title
                    const place = mapData.map_data.places.find(p => {
                        if (!p.title) return false;
                        
                        // Clean up the place title the same way
                        const cleanPlaceTitle = p.title
                            .toLowerCase()
                            .replace(/\s*school$/i, '')
                            .replace(/\s*academy$/i, '')
                            .replace(/\s*elementary$/i, '')
                            .replace(/\s*middle$/i, '')
                            .replace(/\s*high$/i, '')
                            .replace(/[^a-z0-9\s]/g, '') // Remove special characters
                            .replace(/\s+/g, ' ') // Normalize spaces
                            .trim();
                        
                        // Check if the cleaned search text is contained in the cleaned place title
                        return cleanPlaceTitle.includes(cleanSearchText) || 
                               cleanSearchText.includes(cleanPlaceTitle) ||
                               // Check if the words match in any order
                               cleanSearchText.split(' ').every(word => cleanPlaceTitle.includes(word)) ||
                               cleanPlaceTitle.split(' ').every(word => cleanSearchText.includes(word));
                    });
                    
                    if (place) {
                        // Center the map on this place
                        if (place.location && place.location.lat && place.location.lng) {
                            const position = new google.maps.LatLng(
                                parseFloat(place.location.lat),
                                parseFloat(place.location.lng)
                            );
                            mapData.map.setCenter(position);
                            mapData.map.setZoom(15);
                            return;
                        }
                    }
                }
            }
        }
        
        // If no matching pin found, show error message
        $('#map-search-message').html('Location not found on map. Please try searching with a different name.').show();
    });

    // Handle listing container scroll
    if ($(".map__holder").length) {
        function checkScroll() {
            $('.wpgmp_listing_container').each(function () {
                if (this.scrollHeight > this.clientHeight) {
                    $(this).addClass('has-scroll');
                } else {
                    $(this).removeClass('has-scroll');
                }
            });
        }

        // Check initially and on content changes
        checkScroll();
        setInterval(checkScroll, 10); // Check periodically

        var waitForListing = setInterval(function () {
            var listingContainer = $('.map .wpgmp_listing_container');
            if (listingContainer.length) {
                var parentElement = listingContainer.parent();
                parentElement.addClass('map__sidebar__listing');
                parentElement.prepend('<h3 class="sidebar-title">Partner schools</h3>');
                clearInterval(waitForListing);
            }
        }, 100);
    }
    
    // Handle the search form submission
    $('#map-search-form').on('submit', function(e) {
        e.preventDefault();
        
        const address = $('#map-search-input').val();
        
        if (!address) {
            alert('Please enter a ZIP code or address');
            return;
        }
        
        // Check if Google Maps API is available
        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
            alert('Google Maps API is not loaded. Please refresh the page and try again.');
            return;
        }
        
        // Use Google's Geocoding API
        const geocoder = new google.maps.Geocoder();
        
        geocoder.geocode({ 'address': address }, function(results, status) {
            if (status === 'OK' && results[0]) {
                const lat = results[0].geometry.location.lat();
                const lng = results[0].geometry.location.lng();
                const formattedAddress = results[0].formatted_address;
                
                // Try to center the map using the WP Google Maps Pro specific approach
                centerWPGoogleMapsPro(lat, lng, address);
                
                // Always show the Google Maps link as a fallback
                const googleMapsUrl = 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng;
                
                $('#map-search-message').html(
                    'View this location on <a href="' + googleMapsUrl + '" target="_blank">Google Maps</a><br>' +
                    'Found address: ' + formattedAddress
                ).show();
            } else {
                $('#map-search-message').html('Could not find this location. Please try a different search term.').show();
            }
        });
    });
    
    // Function to center the WP Google Maps Pro map
    function centerWPGoogleMapsPro(lat, lng, address) {
        // Find the map element - we know it has class "wpgmp_map"
        const $mapElement = $('.wpgmp_map');
        
        if ($mapElement.length === 0) {
            return false;
        }
        
        // Get the map data from the element
        const mapData = $mapElement.data('wpgmp_maps');
        
        if (mapData) {
            // Try to access the map object
            if (mapData.map) {
                // Try to center the map
                try {
                    // Center the map
                    mapData.map.setCenter(new google.maps.LatLng(lat, lng));
                    
                    // Use the plugin's zoom level if available, otherwise use a default
                    if (mapData.zoom_level) {
                        mapData.map.setZoom(parseInt(mapData.zoom_level));
                    } else {
                        // Use a higher zoom level for better focus on the searched location
                        mapData.map.setZoom(15);
                    }
                    
                    // Try to add a marker
                    if (mapData.map.markers) {
                        // Remove any existing search marker
                        if (window.searchMarker) {
                            window.searchMarker.setMap(null);
                        }
                        
                        // Add a new marker
                        window.searchMarker = new google.maps.Marker({
                            position: new google.maps.LatLng(lat, lng),
                            map: mapData.map,
                            title: 'Searched Location: ' + address,
                            icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
                        });
                    }
                    
                    return true;
                } catch (e) {
                    return false;
                }
            }
        }
        
        // If we couldn't center the map using the data attribute, try using the global objects
        // Check for wpgmp_maps global object
        if (typeof window.wpgmp_maps !== 'undefined' && window.wpgmp_maps[mapId]) {
            try {
                const map = window.wpgmp_maps[mapId].map;
                
                // Center the map
                map.setCenter(new google.maps.LatLng(lat, lng));
                
                // Use the plugin's zoom level if available
                if (window.wpgmp_maps[mapId].zoom) {
                    map.setZoom(parseInt(window.wpgmp_maps[mapId].zoom));
                } else {
                    // Use a higher zoom level for better focus
                    map.setZoom(15);
                }
                
                // Add a marker
                if (window.searchMarker) {
                    window.searchMarker.setMap(null);
                }
                
                window.searchMarker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: map,
                    title: 'Searched Location: ' + address,
                    icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
                });
                
                return true;
            } catch (e) {
                return false;
            }
        }
        
        // Try to find the map in the global scope
        // Look for map10 or similar in the global scope
        const mapElementId = $mapElement.attr('id');
        if (mapElementId && window[mapElementId]) {
            try {
                // Center the map
                window[mapElementId].setCenter(new google.maps.LatLng(lat, lng));
                
                // Try to find the zoom level in the plugin's settings
                let zoomLevel = 15; // Default
                
                // Check if there's a zoom level in the plugin's settings
                if (typeof window.wpgmp_local !== 'undefined' && window.wpgmp_local.zoom) {
                    zoomLevel = parseInt(window.wpgmp_local.zoom);
                }
                
                window[mapElementId].setZoom(zoomLevel);
                
                // Add a marker
                if (window.searchMarker) {
                    window.searchMarker.setMap(null);
                }
                
                window.searchMarker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: window[mapElementId],
                    title: 'Searched Location: ' + address,
                    icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
                });
                
                return true;
            } catch (e) {
                return false;
            }
        }
        
        // Try to use the plugin's built-in functions
        // Check for wpgmp_map_reCenter function
        if (typeof window.wpgmp_map_reCenter === 'function') {
            try {
                window.wpgmp_map_reCenter(lat, lng);
                return true;
            } catch (e) {
                return false;
            }
        }
        
        return false;
    }

    // Handle category checkboxes
    if ($(".map__holder").length) {
        var waitForMap = setInterval(function() {
            if ($('.wpgmp_tab_item').length) {
                // Bind click event
                $('.wpgmp_tab_item input[type="checkbox"]').bind('click', function() {
                    if ($(this).is(':checked')) {
                        // Uncheck other checkboxes and remove their active class
                        $('.wpgmp_tab_item input[type="checkbox"]').not(this).each(function() {
                            $(this).prop('checked', false);
                            $(this).next().removeClass('active');
                        });

                        // Add active class to the current checkbox's next sibling
                        $(this).next().addClass('active');
                    } else {
                        $(this).next().removeClass('active');
                    }
                });

                // Check on page load
                $('.wpgmp_tab_item input[type="checkbox"]').each(function() {
                    if ($(this).is(':checked')) {
                        $(this).next().addClass('active');
                    }
                });

                clearInterval(waitForMap);
            }
        }, 100);
    }
});